/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLetterX = createReactComponent("letter-x", "IconLetterX", [
  ["path", { d: "M7 4l10 16", key: "svg-0" }],
  ["path", { d: "M17 4l-10 16", key: "svg-1" }]
]);

export { IconLetterX as default };
//# sourceMappingURL=IconLetterX.js.map
